module.exports = __webpack_public_path__ + "static/media/UpsellScreen.f683b63c.png";